var RN = require('react-native');

exports._show = RN.ToastAndroid.show

exports.short = RN.ToastAndroid.SHORT

exports.long = RN.ToastAndroid.LONG